export default function EmptyState({ icon = 'bi-inbox', title, hint, children }) {
  return (
    <div className="empty-state">
      <i className={`bi ${icon}`} />
      <div className="fw-semibold">{title}</div>
      {hint ? <div className="small mt-1">{hint}</div> : null}
      {children ? <div className="mt-3">{children}</div> : null}
    </div>
  );
}
